module.exports = __webpack_public_path__ + "html/wave-header_d7dbb67a2aaf8e716eafe96b237ec646.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 55